/**
 * @author Karthik <karthik.x@314ecorp.com>
 * @description Storage Engine
 */

const storageEngine = window.sessionStorage;

export default storageEngine;
